import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';

const SteeringArrangement = ({
  form,
  disabled,
  steeringArrangementTypes,
  defaultValue,
}) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Расположение руля:</span>
      <Form.Item>
        {getFieldDecorator('steeringArrangement')(
          <Select
            placeholder="Выберите расположение руля"
            className="basicInput"
            disabled={disabled}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {steeringArrangementTypes &&
              steeringArrangementTypes.map((item, index) => (
                <Select.Option
                  value={item.vehicleSteeringArrangementId}
                  key={index}
                  label={item.steeringArrangementName}
                >
                  {item.steeringArrangementName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(SteeringArrangement, [
  'steeringArrangementTypes',
]);
